import { Tokens } from '@/assets/tokens'
import { Flex } from '@/components'
import styled from 'styled-components'

export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const DialogContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 45vw;
  max-height: 85vh;
  animation: slideIn 0.3s ease-out;
  position: relative;
  overflow: hidden;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`

export const ModalHeaderContainer = styled(Flex)`
  justify-content: space-between;
  flex-shrink: 0;
  background: white;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid ${Tokens.ColorBackgroundTertiary};

  h1 {
    margin: 30px;
    margin-bottom: 10px;
  }

  button {
    margin: 20px;
    margin-bottom: 10px;
  }
`

export const DialogContent = styled.div`
  flex: 1;
  overflow-y: auto;
  scroll-behavior: smooth;
  max-height: 62.5vh;
  padding: 12px 30px;
  min-height: 0;

  scrollbar-width: thin;
  scrollbar-color: ${Tokens.ColorBackgroundTertiary} transparent;
`

export const DialogFooter = styled.div`
  flex-shrink: 0;
  background: white;
  position: sticky;
  bottom: 0;
  z-index: 1;
  border-top: 1px solid ${Tokens.ColorBackgroundTertiary};
  padding: 20px 30px;
`
